import React from 'react';
import { language } from '../assets/lang';
import { functionsEU } from '../components/firebase/firebase';
import Payment from './payment';
import Transactions from './transactions';
import Share from './share';
import Refund from './refund';
import Lockers from './lockers';
import Vouchers from './vouchers';
import CalendarDay from '../assets/images/icons/calendar-day.svg';
import Map from '../assets/images/icons/map.svg';
import InstaIcon from '../assets/images/icons/instagram.svg';
import ShareIcon from '../assets/images/icons/share2.svg';
import RefundIcon from '../assets/images/icons/refund.svg';
import WalletIcon from '../assets/images/icons/wallet2.svg';
import WhatsappIcon from '../assets/images/icons/whatsapp.svg';
import { QrCode } from "react-qrcode-pretty";

class EventContainer extends React.Component {
    render() {	
        return ( 	
        <div style={{width: '100%', height: '100%', paddingBottom: 30}}>				

            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: this.props.eventData.webQR ? 190 : 210, overflow: 'hidden'}}>
                <img src={this.props.eventData.cover} style={{minWidth: '100%', objectFit: 'contain'}} /> 
                {!this.searchParams.has("evt") && !this.searchParams.has("batch") ? <div className='backbutton' onClick={() => this.props.getEvents()}><i class="fa fa-chevron-left" style={{color: 'rgba(0,0,0,0.6)'}}></i></div> :null}
            </div>
 
            {this.state.eventState === '' ? 
            <div className='contentContainer' style={{marginTop: this.props.eventData.webQR ? -68 : -48}}>

                {this.props.eventData.webQR ?
                <div className='titleContainer titleContainer2'>
                    <div style={{display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: '#f7f7f7', alignItems: 'center', justifyContent: 'center', borderTopLeftRadius: 12, borderTopRightRadius: 12}}> 
                        <QrCode value={'https://card.partypay.nl/?id=' +  this.props.cardID + '&evt=' + (this.props.eventData.eventid ? this.props.eventData.eventid : '')} size={120} color={{eyes: this.props.eventData.webcolor ? this.props.eventData.webcolor : '#b32e5d', body: '#22293b'}} bgColor='#f7f7f7' bgRounded divider />
                    </div>
                    <p style={{fontSize: 12, marginTop: 20, fontFamily: 'Kentledge', color: 'rgba(0,0,0,0.4)', textAlign: 'center'}}>{this.props.eventData.type === 'locatie' ? language.eventlocation : language.event}</p>
                    <p style={{fontSize: 19, marginTop: -2, fontFamily: 'Kentledge-Bold', color: '#22293b', textAlign: 'center'}}>{this.props.eventData.naam}</p>
                    <div className='titleDivider'></div>
                    <p style={{fontSize: 13, lineHeight: 1.5, marginTop: -2, fontFamily: 'Kentledge', marginLeft: 9, color: 'rgba(0,0,0,0.6)', textAlign: 'center'}}>{language.scanatStall}</p>
                </div>
                :
                <div className='titleContainer'>
                    <p style={{fontSize: 12, fontFamily: 'Kentledge', color: 'rgba(0,0,0,0.4)'}}>{this.props.eventData.type === 'locatie' ? language.eventlocation : language.event}</p>
                    <p style={{fontSize: 19, marginTop: -2, fontFamily: 'Kentledge-Bold', color: '#22293b'}}>{this.props.eventData.naam}</p>
                    <div className='titleDivider'></div>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <img src={CalendarDay} style={{width: 17, height: 17, opacity: 0.4, marginLeft: 1}} />
                        <p style={{fontSize: 13, fontFamily: 'Kentledge', marginLeft: 9, color: 'rgba(0,0,0,0.6)'}}>{this.formatDate(this.props.eventData.tijd, this.props.eventData.type, this.props.eventData.dagen)}</p>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center', marginTop: 5}}>
                        <img src={Map} style={{width: 18, height: 18, opacity: 0.4}} />
                        <p style={{fontSize: 13, fontFamily: 'Kentledge', marginLeft: 10, color: 'rgba(0,0,0,0.6)'}}>{this.props.eventData.locatie}</p>
                    </div>
                </div>
                }
                
                <p style={{fontSize: 17, color: '#22293b', fontFamily: 'Kentledge-Bold', marginTop: 45, marginBottom: 15}}>{language.mybalance}</p>
                <div className='saldo' style={{backgroundColor: this.props.eventData.webcolor ? this.props.eventData.webcolor : '#b32e5d'}}>
                    <div style={{justifyContent: 'space-between'}}>
                        {this.props.eventData.useEuro ?
						 <p style={{fontSize: 30, color: '#f1f2f4', fontFamily: 'Kentledge-bold'}}>€ {parseFloat(this.state.userData.tokens ? this.state.userData.tokens : 0).toFixed(2).replace('.',',')}</p>
						:
                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <p style={{fontSize: 30, color: '#f1f2f4', fontFamily: 'Kentledge-bold'}}>{this.state.userData.tokens ? this.state.userData.tokens : 0}</p>
                            <p style={{fontSize: 22, marginLeft: 7, color: 'rgba(255,255,255,0.8)', fontFamily: 'Kentledge', marginTop:1}}>{this.state.userData.tokens === 1 ? language.token : language.tokens}</p>
                        </div>
                        }
                        {this.state.userData.tokens < -0.5 ?
                        <p style={{fontSize: 12, marginTop: 7, color: 'rgba(255,255,255,0.55)', width: 200, fontFamily: 'Kentledge'}}>{language.negativebalancesoonpay}.</p>
                        :
                        <p style={{fontSize: 14, marginTop: 7, color: 'rgba(255,255,255,0.55)', fontFamily: 'Kentledge'}}>{this.state.updating === 'updating' ? language.updatingbalance :null}{this.state.updating === 'updated' ? language.balanceupdated :null}{this.state.updating === 'offline' ? language.noconnection :null}</p>
                        }
                    </div>
                    {this.showSale() ?
                    <div style={{cursor: 'pointer', display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 20}}>
                        <div onClick={() => this.setState({eventState: 'payment', afrekenState: 'tokens'})} style={{display: 'flex', flexDirection: 'row', backgroundColor: '#f1f2f4', paddingLeft: 17, paddingRight: 17, alignItems: 'center', justifyContent: 'space-between', height: 36, width: 182, borderRadius: 20}}>
                            <p style={{fontSize: 12.5, color: this.props.eventData.webcolor ? this.props.eventData.webcolor : '#b32e5d', fontFamily: 'Kentledge'}}>{language.topupbalance}</p>
                            <i class="fa fa-chevron-right" style={{color: this.props.eventData.webcolor ? this.props.eventData.webcolor : '#b32e5d'}}></i>
                        </div>
                    </div>
                    :
                    <div style={{cursor: 'pointer', display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: 20}}>
                        <div onClick={() => this.setState({eventState: 'transactions'})} style={{display: 'flex', flexDirection: 'row', backgroundColor: '#f1f2f4', paddingLeft: 17, paddingRight: 17, alignItems: 'center', justifyContent: 'space-between', height: 36, width: 182, borderRadius: 20}}>
                            <p style={{fontSize: 12.5, color: this.props.eventData.webcolor ? this.props.eventData.webcolor : '#b32e5d', fontFamily: 'Kentledge'}}>{language.viewexpenses}</p>
                            <i class="fa fa-chevron-right" style={{color: this.props.eventData.webcolor ? this.props.eventData.webcolor : '#b32e5d'}}></i>
                        </div>
                    </div>
                    }
                    <div style={{cursor: 'pointer', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginTop: 25}}>
                        <div onClick={() => this.shareTokens()} style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <img src={ShareIcon} style={{width: 16, height: 16, opacity: 0.8}} />
                            <p style={{fontSize: 12.5, marginLeft: 10, color: 'rgba(255,255,255,0.85)', fontFamily: 'Kentledge'}}>{this.props.eventData.muntretour.allowed ? language.share : language.sharetokens}</p>
                        </div>
                        {this.props.eventData.muntretour.allowed ?
                        <div onClick={() => this.setState({eventState: 'refund'})} style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <img src={RefundIcon} style={{width: 14, height: 14, opacity: 0.8}} />
                            <p style={{fontSize: 12, marginLeft: 6, color: 'rgba(255,255,255,0.85)', fontFamily: 'Kentledge'}}>{language.refund}</p>
                        </div>
                        :null}
                        {this.showSale() ?
                        <div onClick={() => this.setState({eventState: 'transactions'})} style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <img src={WalletIcon} style={{width: 16, height: 16, opacity: 0.8}} />
                            <p style={{fontSize: 12.5, marginLeft: 10, color: 'rgba(255,255,255,0.85)', fontFamily: 'Kentledge'}}>{language.spendings}</p>
                        </div>
                        :
                        <div onClick={() => this.openCustomerService()} style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                            <img src={WhatsappIcon} style={{width: 17, height: 17, opacity: 0.7}} />
                            <p style={{fontSize: 12.5, marginLeft: 8, color: 'rgba(255,255,255,0.85)', fontFamily: 'Kentledge'}}>{language.needhelp}</p>
                        </div>
                        }
                    </div>
                    <div style={{height: 15}}>	
                    </div>
                    <div onClick={() => this.getSaldo()} className={this.state.updating === "updating" ? "rotating" : ""} style={{position: 'absolute', height: 30, right: 30, display: 'flex', alignItems: 'center', justifyContent: 'center', right: 17, top: 13, zIndex: 999, cursor: 'pointer'}}>
                        <i class="fa fa-arrows-rotate" style={{fontSize: 20, color: '#fff', opacity: 0.8}}></i>
                    </div>
                </div>

                {this.props.eventData.weblinks && this.props.eventData.weblinks.length > 0 ? 
                <div>
                    <p style={{fontSize: 17, color: '#22293b', fontFamily: 'Kentledge-Bold', marginTop: 45, marginBottom: 20}}>{language.info}</p>
                    <div>
                        {this.props.eventData.weblinks.map((item, index) => (
                        <div className='btn_container' onClick={() => this.openWeblink(item.url)}>
                            <p style={{fontSize: 14, color: '#22293b', fontFamily: 'Kentledge', textAlign: 'left'}} numberOfLines={1}>{item.text}</p>          
                            <i class="fa fa-chevron-right" style={{color: '#22293b', fontSize: 14}}></i>
                        </div>
                        ))}
                    </div>
                </div>
                :null}

                <p style={{fontSize: 17, color: '#22293b', fontFamily: 'Kentledge-Bold', marginTop: 45, marginBottom: 20}}>{language.announcements}</p>
                <div>
                    {this.props.eventData.announcements && this.props.eventData.announcements.length > 0 ? this.props.eventData.announcements.map((item, index) => (
                        <div key={index} className='announcement_container'>						
                            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 20}}>							
                                <div style={{width: 50, height: 50, overflow: 'hidden', display: 'flex', flexShrink: 0, justifyContent: 'center', alignItems: 'center', borderRadius: 25}}>
                                    <img src={this.props.eventData.cover} style={{width: 180, height: 100}} /> 
                                </div>
                                <div style={{marginLeft: 15}}>
                                    <p style={{fontSize: 16, color: '#22293b', fontFamily: 'Kentledge-Bold'}}>{item.naam}</p>
                                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: -2}}>
                                        <p style={{fontSize: 12, color: 'rgba(0,0,0,0.5)', fontFamily: 'Kentledge'}}>{language.postedon} {this.formattime(item.tijd)}</p>
                                    </div>
                                </div>
                            </div>							
                            <p style={{fontSize: 15, color: '#22293b', fontFamily: 'Kentledge'}}>{item.title}</p>
                            <p style={{fontSize: 12, marginTop: 15, color: '#22293b', fontFamily: 'Kentledge'}}>{item.text}</p>
                            {item.buttonUrl ?
                            <center>
                                <a href={item.buttonUrl} style={{display: 'flex', flexDirection: 'row', marginTop: 25, backgroundColor: this.props.eventData.webcolor ? this.props.eventData.webcolor : '#b32e5d', paddingLeft: 20, paddingRight: 20, width: 'fit-content', alignItems: 'center',  justifyContent: 'space-between', height: 36, borderRadius: 20}}>
                                    <p style={{fontSize: 12.5, color: '#fff', fontFamily: 'Kentledge', marginLeft: 5, marginRight: 25}}>{item.buttonText && item.buttonText !== '' ? item.buttonText : language.gotolink}</p>
                                    <i class="fa fa-chevron-right" style={{color: '#fff', fontSize: 14}}></i>
                                </a>
                            </center>
                            :null}
                        </div>
                    )):
                    <div className='announcement_container' style={{height: 130, justifyContent: 'center', alignItems: 'center'}}>
                        <p style={{opacity: 0.4, textAlign: 'center', fontSize: 15, fontFamily: 'Kentledge'}}>{language.noannouncements}</p>
                    </div>
                    }
                </div>

            </div>  
            :null}  

            {this.state.succesNoticeModal ?
            <div className="modal-overlay succesNoticeModal" style={{backgroundColor: 'rgba(0,0,0,0.75)'}} onClick={()=>this.setState({succesNoticeModal: false})}>
                <div className="modal-content" style={{padding: 0, paddingBottom: 35, boxShadow: "0 0 20px 5px rgba(255, 255, 255, 0.4)", borderRadius: 8}}>
                    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                        <div style={{display: 'flex', width: '100%', height: 148, alignItems: 'center', justifyContent: 'center', borderTopLeftRadius: 8, borderTopRightRadius: 8, overflow: 'hidden'}}>
                            <img src={this.props.eventData.cover} style={{minWidth: '100%', objectFit: 'contain'}} /> 
                            <div onClick={() => this.setState({succesNoticeModal: false})} style={{position: 'absolute', top: 0, right: 0, width: 45, height: 45, display: 'flex', justifyContent: 'center', alignItems: 'center'}}> <i class="fa fa-times" style={{color: 'rgba(255,255,255,0.2)', fontSize: 20}}></i></div>
                        </div>
                        <div className="progress-bar-container"><div className="progress-bar-fill"></div></div>
                        <div style={{paddingLeft: 45, paddingRight: 45, marginTop: 35, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                            <p style={{fontSize: 18, color: '#22293b', fontFamily: 'Kentledge-Bold', textAlign: 'center'}}>{language.thanksfortopup}</p>
                            <p style={{fontSize: 13, color: '#22293b', marginTop: 15, fontFamily: 'Kentledge', textAlign: 'center'}}>{language.followinsta}</p>
                            <button onClick={() => window.location.href = this.props.eventData.webInsta} style={{display: "flex", marginTop: 30, alignItems: "center", gap: "8px", background: "linear-gradient(90deg, #f58529, #dd2a7b, #8134af, #515bd4)", border: "none", borderRadius: "30px", padding: "10px 20px", color: "white", fontWeight: "bold", cursor: "pointer"}}>
                                <img src={InstaIcon} alt="Instagram" style={{ width: "24px", height: "24px" }}/> 
                                FOLLOW US 
                            </button>
                        </div>
                    </div>
                </div>
			</div>
			:null}  

            {this.state.imgModal ? 
            <div className="modal-overlay" onClick={()=>this.setState({imgModal: false})}>
                <img src={this.state.imgUrl} style={{maxWidth: '90%', maxHeight: '90%', objectFit: 'cover', borderRadius: 15}}/>
                <div onClick={()=>this.setState({imgModal: false})} style={{position: 'absolute', width: 90, height: 40, display: 'flex', alignItems: 'center', backgroundColor: this.props.eventData.webcolor ? this.props.eventData.webcolor : '#b32e5d', borderRadius: 10, cursor: 'pointer', justifyContent: 'center', bottom: 30}}>
                    <i class="fa fa-chevron-down" style={{color: '#fff', fontSize: 14}}></i>
                    <p style={{fontSize: 14, marginLeft: 8, color: '#fff', fontFamily: 'Kentledge', textAlign: 'center'}}>Close</p>
                </div>
            </div>
            :null}   

            {this.state.eventState === 'transactions' ? <Transactions changeEventState={this.changeEventState} userData={this.state.userData} eventData={this.props.eventData} /> :null}
            {this.state.eventState === 'payment' ? <Payment changeEventState={this.changeEventState} cardID={this.props.cardID} eventData={this.props.eventData} userData={this.state.userData} afrekenState={this.state.afrekenState} /> :null}	
            {this.state.eventState === 'share' ? <Share changeEventState={this.changeEventState} userData={this.state.userData} eventData={this.props.eventData} /> :null}	
            {this.state.eventState === 'refund' ? <Refund changeEventState={this.changeEventState} userData={this.state.userData} eventData={this.props.eventData} /> :null}	
            {this.state.eventState === 'lockers' ? <Lockers changeEventState={this.changeEventState} cardID={this.props.cardID} userData={this.state.userData} eventData={this.props.eventData} /> :null}	
            {this.state.eventState === 'vouchers' ? <Vouchers changeEventState={this.changeEventState} cardID={this.props.cardID} userData={this.state.userData} eventData={this.props.eventData} /> :null}	
        
        </div>
        )
    }

    state = {userData: '', updating: 'updated', eventState: '', afrekenState: '', succesNoticeModal: false}

    componentDidMount(){this.getSaldo(); this.checkPayment()}
    
    getSaldo(){
        this.setState({updating: 'updating'});
        var getCardBalance = functionsEU.httpsCallable('getCardBalance');
        getCardBalance({cardID: this.props.cardID, eid: this.props.eventData.eventid}).then(result => { 
            if(result.data.state === 1){this.setState({updating: 'updated', userData: result.data.data})}
            else{this.setState({updating: 'updated'})}
        }).catch(e => {console.log(e); this.setState({updating: 'offline'})});
    }

    checkPayment(){
        var url = new URL(window.location.href);
        if(url.searchParams.has("locker")){
            url.searchParams.delete("locker");
            window.history.replaceState({}, document.title, url);
            this.setState({eventState: 'lockers'});
        }
        if(url.searchParams.has("payment") && this.props.eventData.webInsta && this.props.eventData.webInsta != ''){
            url.searchParams.delete("payment");
            window.history.replaceState({}, document.title, url);
            this.setState({succesNoticeModal: true},()=> setTimeout(() => this.setState({succesNoticeModal: false}), 5000));
        }
    }

    openWeblink(url){
        if(url === '#lockers'){this.setState({eventState: 'lockers'})}
        else if(url === '#vouchers'){this.setState({eventState: 'vouchers'})}
        else if(url === '#klantenservice'){this.openCustomerService()}
        else if(url.includes('image=')){this.setState({imgModal: true, imgUrl: url.replace('image=','')})}
        else{window.open(url, '_blank')}
    }

    openCustomerService(){
        window.open('https://wa.me/+31854011114?text=My account number is ' + this.props.cardID + '---' + this.state.userData.id + ' and my question is: ', '_blank');
    }

    formatDate(tijd, type, dagen){
        if(type === 'event'){
            var date = new Date(0);
            date.setUTCSeconds(tijd);
            var maand = ' ' + language.months[date.getMonth()] + ' ';
            if(dagen && dagen > 1){
                var date2  = new Date(date);
                date2.setDate(date.getDate() + (dagen -1))
                if(date.getMonth() === date2.getMonth()){
                    maand = ' ' + language.tm + ' ' + date2.getDate() + ' ' + language.months[date.getMonth()] + ' ';
                }
                else{
                    maand = ' ' + language.months[date.getMonth()] + ' ' + language.tm + ' ' + date2.getDate() + ' ' + language.months[date2.getMonth()] + ' ';
                }
            }		
            return '' + date.getDate() + maand + date.getFullYear();
        }
        return language.eventlocation;
    }

    formattime(tijd){
        var datum = new Date(0);
        datum.setUTCSeconds(tijd);
        var minuten = datum.getMinutes();
        if(datum.getMinutes() < 10){minuten = '0' + datum.getMinutes()}
        var timestamp = datum.getDate() + ' ' + language.monthsshort[datum.getMonth()] + ' ' + language.at + ' ' + datum.getHours() + ':' + minuten;
        return timestamp;
    }

    shareTokens(){
        var url = new URL(window.location.href);
        if(this.props.eventData.preventShare || url.searchParams.has("preventShare")){alert(language.nosharedesc)}
        else{this.setState({eventState: 'share'})}
    }

    showSale(){
        var url = new URL(window.location.href);
        if(this.props.eventData.webnosale || url.searchParams.has("preventSale")){return false}
        return true;
    }

    changeEventState = (state, refresh, afrekenState) => {
        this.setState({eventState: state, afrekenState: afrekenState ? afrekenState : ''},()=>{
            window.scrollTo(0,0);
            if(refresh){this.getSaldo()}
        })
    }

    searchParams = new URL(window.location.href).searchParams;
    
    }
    
    export default EventContainer;